import styled from 'styled-components';
import AppCSS from '../../../utils/styled';
import { DefaultModalComponents } from '../../ProjectModal/utils';

export const Components = {
  ...DefaultModalComponents,
  Section: styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 8px;
  `,
  FieldLabel: styled.span`
    ${AppCSS.fonts.label12Bold};
    color: ${AppCSS.colors.blues.veryDark};
  `,
  FieldHint: styled.span`
    ${AppCSS.fonts.label12Regular};
    color: ${AppCSS.colors.greys.prettyDark};
  `,
  AudioPlayer: styled.audio`
    width: 100%;
  `,
};
